import styled from 'styled-components';

export const ContLogo = styled.div`
  width: 159px;
  height: 82px;
  
  @media(min-width: 300px) and (max-width: 767px){
    width: 73px;
    height: auto;
  }
  @media(min-width: 768px) and (max-width: 1023px){
    width: 90px;
    height: auto;
  }
  @media(min-width: 1024px) and (max-width: 1079px){
    width: 100px;
    height: auto;
  }
  @media(min-width: 1080px) and (max-width: 1219px){
    width: 120px;
    height: auto;
  }
  @media(min-width: 1280px) and (max-width: 1407px){
    width: 120px;
    height: auto;
  }
  @media(min-width: 1408px) and (max-width: 1439px){
    width: 120px;
    height: auto;
  }
  @media(min-width: 1440px) and (max-width: 1919px){
    width: 120px;
    height: auto;
  }
  @media(min-width: 1920px){
    
  }
`
export const ImgLogo = styled.img`
  width: 100%;
  height: 100%;
`
